import { FC } from "react";
import { CALENDAR_SWITCH_VALUES } from "../../constants";
import { useTheme, Theme } from "@mui/material/styles";
import { SxProps, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { atom, useAtom } from "jotai";

interface ICalendarFilterSwitchProps {
  sx?: SxProps;
}

export const selectedTabAtom = atom(CALENDAR_SWITCH_VALUES.CALENDAR);

const ToggleButtonGroupStyles = (theme: Theme) => ({
  backgroundColor: theme.custom.disabledColor,
  borderRadius: "4px",
  height: "36px",
  "& .MuiToggleButtonGroup-grouped": {
    margin: "3px",
    border: 0,
    padding: "0 8px",
    textTransform: "capitalize",
    fontSize: "13px",
    ":hover": {
      backgroundColor: "rgba(255,255,255,0.4)"
    },
    "&.Mui-selected": {
      color: theme.custom.mainButtonHighlight,
      "&, :hover": {
        backgroundColor: theme.custom.white
      }
    },
    "&.Mui-disabled": {
      border: 0
    },
    "&:not(:first-of-type)": {
      borderRadius: "4px",
      marginLeft: "2px"
    },
    "&:first-of-type": {
      borderRadius: "4px",
      marginRight: "2px"
    }
  }
});

const CalendarFilterSwitch: FC<ICalendarFilterSwitchProps> = ({ sx }) => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useAtom(selectedTabAtom);

  const handleToggle = (_, newValue: string | null) => {
    if (newValue !== null) {
      setSelectedTab(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      size="small"
      onChange={handleToggle}
      value={selectedTab}
      exclusive
      sx={{
        ...ToggleButtonGroupStyles(theme),
        ...sx
      }}
    >
      <ToggleButton value={CALENDAR_SWITCH_VALUES.CALENDAR}>
        Calendar
      </ToggleButton>
      <ToggleButton value={CALENDAR_SWITCH_VALUES.MEETING_LIST}>
        Cloud Recordings
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

CalendarFilterSwitch.defaultProps = {
  sx: {}
};

export default CalendarFilterSwitch;
